var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documentsDetail-box"},[_c('div',{staticClass:"detail-top"},[_c('div',{staticClass:"return-btn",on:{"click":function($event){return _vm.$router.push('/documentsList')}}},[_vm._v(" 返回列表 ")])]),_c('iframe',{staticClass:"detail-bot",attrs:{"frameborder":"0","width":"100%","height":"500px","src":_vm.docInfo.wsUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }